'use es6';

import Cookies from 'js-cookie';
export var UNKNOWN_UTK = 'unknown';

var getHstc = function getHstc() {
  return Cookies.get('__hstc') || null;
};

export var getUtk = function getUtk() {
  var utk = Cookies.get('hubspotutk');

  if (!utk) {
    utk = getHstc();

    if (utk) {
      utk = utk.split('.')[1];
    }
  }

  return utk || null;
};